// TODO: review and move to different controller
// app/javascript/controllers/global_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  newZettel(event) {
    event.preventDefault();
    document.dispatchEvent(new CustomEvent("pane-stack:new", { detail: { url: event.currentTarget.href } }));
  }
}
